var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Layout } from 'src/core/components';
import ComplaintForm from 'src/complaint/components/ComplaintForm';
import { useRouter } from 'src/core/hooks';
export var NewComplaint = function () {
    var router = useRouter('complaints');
    return (_jsx(Layout, __assign({ meta: { title: 'Confirm Order' } }, { children: _jsx(ComplaintForm, { action: "create", onSuccess: router.go, onCancel: router.go }, void 0) }), void 0));
};
